import { ENTER_KEY_CODE } from '../../utils/constants';
import messages from '../../pages/profile/messagesGamesPlayed';
import { useIntl } from 'react-intl';

interface OwnProps {
  onClick: () => void;
}

const BigAddButton = (props: OwnProps) => {
  const intl = useIntl();

  return (
    <div
      className="card add"
      onClick={props.onClick}
      tabIndex={0}
      onKeyDown={(e: any) => {
        if (e.keyCode == ENTER_KEY_CODE) e.target.click();
      }}
    >
      <span>+</span>
      <span>{intl.formatMessage({ ...messages.addGame })}</span>
    </div>
  );
};

export default BigAddButton;
